import React from "react";
import LuckyDrawListingTable from "../../table/luckyDrawListingTable";
import { Box, Tabs, makeStyles } from "@material-ui/core";
import WithProductDateProgressSearch from "../../../../../components/search/withProductDateProgressSearch";
import CustomTab from "components/tab";
import { TabPanel } from "components/tabPanel";
import { getLang } from "app/feature/constants";
import { TYPE_TRADITIONAL_RAFFLE, TYPE_INSTANT_WIN } from "../../../constants";

const useStyles = makeStyles((theme) => ({
  indicator: {
    border: "0.5px solid",
    borderColor: theme.palette.primary.main,
  },
  scroll: {
    width: "min-content",
  },
}));

export default function LuckyDrawListingPanelComponent({
  hasLuckyDrawEditAccessRight,
  isFetching,
  activeTab,
  handleTabChange,
  page,
  rowsPerPage,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleSearch,
  handleStatusChange,
  handleFetchLuckyDrawList,
  paginationOptions,
  language,
  productDropdown,
  isFetchingProduct,
  lang,
  isError,
  handleLiveDraw,
  handleAddLuckyDraw,
  handleAddInstantWin,
  handleBinding,
  handleDownloadWinner,
  handlePublished,
  handleEnd,
  handleJoinClose,
  data,
  searchValue,
  filterValues,
}) {
  const classes = useStyles();

  function a11yProps(index, label) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tab-${index}`,
      label: label,
    };
  }

  return (
    <>
      {/* Tab Navigation - Separate Box like Product List */}
      <Box>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="scrollable auto tabs example"
          textColor="primary"
          variant="scrollable"
          indicatorColor="primary"
          classes={{
            indicator: classes.indicator,
            scrollButtons: classes.scroll,
          }}
        >
          <CustomTab
            {...a11yProps(0, `${getLang(lang, "label.TRADITIONAL_RAFFLE")}`)}
          />
          <CustomTab
            {...a11yProps(1, `${getLang(lang, "label.INSTANT_WIN")}`)}
          />
        </Tabs>
      </Box>

      {/* Shared Search Component - Outside tabs to prevent unmounting */}
      <WithProductDateProgressSearch
        handleFilter={(value) => {
          handleSearch(value);
        }}
        productDropdown={productDropdown}
        isFetchingProduct={isFetchingProduct}
        searchValue={searchValue}
        filterValues={filterValues}
      />

      {/* Tab Content - Tables only */}
      <Box>
        <TabPanel value={activeTab} index={0}>
          <LuckyDrawListingTable
            hasLuckyDrawEditAccessRight={hasLuckyDrawEditAccessRight}
            isFetching={isFetching}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRecords={totalRecords}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleStatusChange={handleStatusChange}
            handleFetchLuckyDrawList={handleFetchLuckyDrawList}
            paginationOptions={paginationOptions}
            lang={lang}
            language={language}
            isError={isError}
            handleLiveDraw={handleLiveDraw}
            handleAddLuckyDraw={handleAddLuckyDraw}
            handleAddInstantWin={handleAddInstantWin}
            handleBinding={handleBinding}
            handleDownloadWinner={handleDownloadWinner}
            handlePublished={handlePublished}
            handleEnd={handleEnd}
            handleJoinClose={handleJoinClose}
            data={data}
            gameType={TYPE_TRADITIONAL_RAFFLE}
          />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <LuckyDrawListingTable
            hasLuckyDrawEditAccessRight={hasLuckyDrawEditAccessRight}
            isFetching={isFetching}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRecords={totalRecords}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleStatusChange={handleStatusChange}
            handleFetchLuckyDrawList={handleFetchLuckyDrawList}
            paginationOptions={paginationOptions}
            lang={lang}
            language={language}
            isError={isError}
            handleLiveDraw={handleLiveDraw}
            handleAddLuckyDraw={handleAddLuckyDraw}
            handleAddInstantWin={handleAddInstantWin}
            handleBinding={handleBinding}
            handleDownloadWinner={handleDownloadWinner}
            handlePublished={handlePublished}
            handleEnd={handleEnd}
            handleJoinClose={handleJoinClose}
            data={data}
            gameType={TYPE_INSTANT_WIN}
          />
        </TabPanel>
      </Box>
    </>
  );
}
